import uaaApi from "../../../../../api/uaaConfig";

export const getUserInfo = (params) => {
  return uaaApi({ method: "get", url: "/api/v1/user", params });
};

export const createUpdateUser = (data, method) => {
  return uaaApi({ method, url: "/api/v1/user", data });
};

export const getRoleUser = (params) => {
  return uaaApi({ method: "get", url: "/api/v1/role/list-by-user", params });
};

export const getProductUser = (params) => {
  return uaaApi({
    method: "get",
    url: "/api/v1/product/list-by-user",
    params,
  });
};

export const modifyRoleUser = (params) => {
  return uaaApi({ method: "put", url: "/api/v1/user/modify-role", params });
};

export const getListRole = (params) => {
  return uaaApi({
    method: "get",
    url: "/api/v1/role/list",
    params: { ...params, page: 0, size: 100 },
  });
};

export const getListProduct = () => {
  return uaaApi({
    method: "get",
    url: "/api/v1/product/list",
    params: { page: 0, size: 100 },
  });
};
